module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs p-compare-reserve"
  }, [_c('h2', {
    staticClass: "u-centre chart"
  }, [_vm._v("Difference between " + _vm._s(_vm.fromLabel) + " and " + _vm._s(_vm.toLabel))]), _vm._v(" "), (_vm.theCurrentWidth >= 600) ? _c('range-chart', {
    attrs: {
      "claims": _vm.claims,
      "range": _vm.range
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04b59c3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/RangeChartContainer.vue
// module id = 1559
// module chunks = 0